import React from 'react';
import { CustomTextField } from '../../../../../../../components/CustomTextField';
import { CustomSelect } from '../../../../../../../components/CustomSelect';
import { CustomSwitch } from '../../../../../../../components/CustomSwitch';
import { DEDUCTION_CALCULATION_TYPE_MODEL } from '../Model/Model';
import {getCalculationTypeById} from "../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 *
 * Shared form for create and update deduction policy modals.
 */
const DeductionPolicyForm = ({ item, setItem, emptyFields, disabled = false, idSuffix = '', isValidValue, isValidValueText }) => {
    const calculationType = getCalculationTypeById(item.calculationType);
    const suffix = idSuffix ? `_${idSuffix}` : '';

    return (
        <div className='row'>
            <div className='col-12'>
                <CustomTextField
                    id={`txt_dpf_name${suffix}`}
                    name='name'
                    value={item.name}
                    trans='name'
                    type='text'
                    required
                    emptyFields={emptyFields}
                    length={128}
                    disabled={disabled}
                    onChange={(e) => setItem(prev => ({ ...prev, name: e.target.value }))}
                />
            </div>

            <div className='col-12 col-md-6'>
                <CustomSelect
                    id={`slt_dpf_calculation_type${suffix}`}
                    name='calculationType'
                    value={item.calculationType}
                    keyName='id'
                    list={DEDUCTION_CALCULATION_TYPE_MODEL()}
                    trans='calculation_type'
                    label='calculationType'
                    required
                    emptyFields={emptyFields}
                    disabled={disabled}
                    showNoSelectionOption={false}
                    onChange={(e) => setItem(prev => ({ ...prev, calculationType: e.target.value, value: '' }))}
                />
            </div>

            <div className='col-12 col-md-6'>
                <CustomTextField
                    id={`txt_dpf_value${suffix}`}
                    name='value'
                    value={item.value}
                    trans='value'
                    type='text'
                    required
                    emptyFields={item.calculationType ? emptyFields : false}
                    length={10}
                    decimals={2}
                    disabled={disabled || !item.calculationType}
                    suffixText={
                        <p className='ibl-font-w-600 text-uppercase'>
                            {calculationType?.prefixText}
                        </p>
                    }
                    isValid={item.calculationType && !disabled ? isValidValue : true}
                    isValidText={isValidValueText}
                    onChange={(e) => setItem(prev => ({ ...prev, value: e.target.value }))}
                />
            </div>

            <div className='col-12 col-md-6 input-padding-bottom'>
                <CustomSwitch
                    id={`cs_dpf_is_mandatory${suffix}`}
                    name='isMandatory'
                    trans='is_mandatory'
                    checked={item.isMandatory}
                    showBorder
                    disabled={disabled}
                    onChange={(e) => setItem(prev => ({ ...prev, isMandatory: e.target.checked }))}
                />
            </div>
        </div>
    );
};

export default DeductionPolicyForm;
